import { useLanguage } from "../i18n/LanguageContext";
import { TitleLines } from "../i18n/text";

/**
 * С чем работает Table One: касса, программа лояльности, способы оплаты.
 * Ресторан выбирает решение по тому, встанет ли оно в его контур, — поэтому
 * раздел отвечает на этот вопрос прямо, без «свяжитесь с нами».
 */
export function IntegrationsSection() {
    const { t } = useLanguage();

    return (
        <section className="section integrationsSection" id="integrations">
            <div className="sectionText">
                <p className="eyebrow">{t.integrations.eyebrow}</p>

                <h2>
                    <TitleLines lines={t.integrations.titleLines} />
                </h2>

                <p className="lead">{t.integrations.lead}</p>
            </div>

            <div className="integrationGroups">
                {t.integrations.groups.map((group) => (
                    <article className="integrationGroup" key={group.title}>
                        <span className="integrationIcon">{group.icon}</span>

                        <div className="integrationBody">
                            <h3>{group.title}</h3>
                            <p>{group.text}</p>

                            <ul className="integrationBadges">
                                {group.items.map((item) => (
                                    <li className="integrationBadge" key={item.name} title={item.name}>
                                        <img className="integrationLogo" src={item.logo} alt={item.name} />
                                        {item.suffix ? (
                                            <span className="integrationSuffix" aria-hidden="true">
                                                {item.suffix}
                                            </span>
                                        ) : null}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </article>
                ))}
            </div>
        </section>
    );
}
